var map = {
	"./configuration/365Page.png": "5d47",
	"./configuration/About.png": "fc74",
	"./configuration/AccountPage.png": "8437",
	"./configuration/AttractionsPage.png": "a373",
	"./configuration/CamerasPage.png": "9c32",
	"./configuration/Cart.png": "600c",
	"./configuration/ChannelsPage.png": "3022",
	"./configuration/ClockPage.png": "e2c3",
	"./configuration/CruiseOffers.png": "72aa",
	"./configuration/DailySchedule.png": "3ff9",
	"./configuration/ExcursionPage.png": "5f2c",
	"./configuration/FiloxeniaAudio.png": "f0fc",
	"./configuration/FiloxeniaAudioFS.png": "447f",
	"./configuration/FiloxeniaCinema.png": "1e81",
	"./configuration/GaleryPage.png": "9118",
	"./configuration/GamesPage.png": "99aa",
	"./configuration/HDMIPage.png": "d319",
	"./configuration/HotelInfo.png": "01e2",
	"./configuration/InstructionPage.png": "6d19",
	"./configuration/InternetAccess.png": "d042",
	"./configuration/MapPage.png": "b265",
	"./configuration/MenuPage.png": "ea5f",
	"./configuration/Messenger.png": "c492",
	"./configuration/NavigationPage.png": "e2cf",
	"./configuration/Page365.png": "07bb",
	"./configuration/PaintingModePage.png": "afc0",
	"./configuration/PersonalArea.png": "9da1",
	"./configuration/RadioPage.png": "c5bf",
	"./configuration/RooomControl.png": "0c78",
	"./configuration/RouteInfo.png": "499a",
	"./configuration/SettingsPage.png": "42b0",
	"./configuration/Staff.png": "e053",
	"./configuration/WeatherPage.png": "c5aa",
	"./configuration/bar.png": "fdd9",
	"./configuration/internet.png": "a97c",
	"./configuration/oflineMap.png": "7f74",
	"./configuration/person-circle.svg": "65d0",
	"./configuration/service.png": "226f",
	"./configuration/test.png": "1879",
	"./flags/de.png": "64ce",
	"./flags/depositphotos_25484359-stock-illustration-european-icons-round-flags.jpg": "0259",
	"./flags/en.png": "1409",
	"./flags/es.png": "31be",
	"./flags/fr.png": "d86f",
	"./flags/it.png": "ead4",
	"./flags/ja.png": "b226",
	"./flags/ko.png": "42c7",
	"./flags/nl.png": "97b8",
	"./flags/pl.png": "98ec",
	"./flags/pt.png": "742a",
	"./flags/ru.png": "aad4",
	"./flags/tr.png": "1af2",
	"./flags/uk.png": "0e52",
	"./flags/zh.png": "329a",
	"./icons/icons8-children-50.png": "04eb",
	"./icons/icons8-microsoft-excel-2019-48.png": "809f",
	"./icons/icons8-pensioner-50.png": "ab94",
	"./icons/z-it.png": "865e",
	"./logos/full_zit.png": "090f",
	"./logos/mini_zit.png": "a01d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb61";